import * as React from 'react';

import Box from '@mui/material/Box';
import ProcessIcon1 from '../../assets/process-01.svg';
import ProcessIcon2 from '../../assets/process-02.svg';
import ProcessIcon3 from '../../assets/process-03.svg';
import ProcessIcon4 from '../../assets/process-04.svg';

export default function Process(){
    return (

        <Box className="wrapper process">
            <h2 className="section-title">Selection Process</h2>
            {/* <p className="desc">Shortlisted candidates will go through 4 rounds of interviews.</p> */}
            <Box className="content">
                <Box className="item">
                <Box className="icon-wrapper">
                    <Box className="icon" style={{ backgroundImage: `url(${ProcessIcon1})`}}></Box>
                </Box>
                <Box className="description">
                    <p className="index">01</p>
                    <p className="title">Online</p>
                    <p className="title">Assessment</p>
                    <p className="sub-title">August - October</p>
                </Box>
                </Box>
                <Box className="item">
                <Box className="icon-wrapper">
                    <Box className="icon" style={{ backgroundImage: `url(${ProcessIcon2})`}}></Box>
                </Box>
                <Box className="description">
                    <p className="index">02</p>
                    <p className="title">HR and Technical</p>
                    <p className="title">Speed Interview</p>
                    <p className="sub-title">September - October</p>
                </Box>
                </Box>
                <Box className="item">
                <Box className="icon-wrapper">
                    <Box className="icon" style={{ backgroundImage: `url(${ProcessIcon3})`}}></Box>
                </Box>
                <Box className="description">
                    <p className="index">03</p>
                    <p className="title">Group Case</p>
                    <p className="title">Assessment</p>
                    <p className="sub-title">October - November</p>
                </Box>
                </Box>
                <Box className="item">
                <Box className="icon-wrapper">
                    <Box className="icon" style={{ backgroundImage: `url(${ProcessIcon4})`}}></Box>
                </Box>
                <Box className="description">
                    <p className="index">04</p>
                    <p className="title">Interview with</p>
                    <p className="title">Finance Leadership Team</p>
                    <p className="sub-title">November</p>
                </Box>
                </Box>
            </Box>
            <Box className="ps">Shortlisted applicants will be notified and invited for interviews on a rolling basis.</Box>
            {/* <a className="btn-apply" href="https://career.sea.com/position/J00256013" style={{minWidth: "100px"}}>APPLY NOW</a> */}
        </Box>
        
        
    );
}